import * as R from 'ramda'
import tzlookup from 'tz-lookup'
import * as momentTimeZone from 'moment-timezone'
import * as moment from 'moment'

const TIMEZONE_ZERO = 'UTC'

export const API_DATE_FORMATTED = 'YYYY-MM-DD HH:mm'
export const CALENDAR_DATE_FORMATTED = 'YYYY-MM-DD HH:mm:ss'
export const DISPLAY_FORMAT_DATE = 'MMMM DD, YYYY'
export const DATEPICKER_DATE_FORMAT = 'MMMM dd, yyyy'
export const DATE_TIME_PICKER_FORMAT = 'MMMM dd, yyyy, h:mm a'
export const DATE_TIME_PREVIEW = 'MMMM DD, YYYY, h:mm A ([GMT]Z)'
export const VOUCHER_DATE_START_FORMAT = 'YYYY-MM-DD 00:00'
export const VOUCHER_DATE_END_FORMAT = 'YYYY-MM-DD 23:59'
export const DISPLAY_FORMAT_DATE_US = 'MMMM dd, yyyy'
export const DATE_FORMAT_VOUCHER = 'MMM DD, YYYY'
export const DATE_FORMAT = 'MMMM dd, yyyy, h:mm a'
export const MEDIUM_DATE_TIME_FORMAT = 'MMM DD, YYYY, h:mm A'
// export const MEDIUM_DATE_TIME_FORMAT_TWO = 'MMM D, YYYY, h:mm A'
export const API_DATE_ONLY_FORMAT = 'YYYY-MM-DD'
export const DATE_PICKER_FORMAT = 'MM/dd/yyyy'

export const getTimezoneIdFromPlace = (place) => {
  const latitude = R.view(R.lensPath(['info', 'latitude']), place)
  const longitude = R.view(R.lensPath(['info', 'longitude']), place)

  return latitude && longitude ? tzlookup(latitude, longitude) : TIMEZONE_ZERO
}

export const createSameDateWithNewTimezone = (
  date,
  timezone = TIMEZONE_ZERO,
) =>
  R.isNil(date)
    ? undefined
    : momentTimeZone.tz(moment(date).format(API_DATE_FORMATTED), timezone)

export const changeTimezone = (date, timezone = TIMEZONE_ZERO) =>
  R.isNil(date) ? undefined : momentTimeZone(date).tz(timezone)

export const convertToTimezoneUTC = (momentObj) => {
  return momentObj.utc()
}

export const isPastDate = (dateTime) => {
  return moment(dateTime).isBefore(moment())
}

export const isPastStartDateVoucher = (dateTime) => {
  return moment(dateTime).startOf('day').diff(moment().startOf('day')) < 1
}

export const isPastEndDateVoucher = (dateTime) => {
  return moment(dateTime).endOf('day').diff(moment().startOf('day')) < 1
}

const mapMoment = (map) =>
  R.ifElse(R.isNil, R.always(null), R.compose(map, moment))

export const relativeDateDisplay = mapMoment((date) => date.fromNow())

export const mediumDateDisplay = mapMoment((date) =>
  date.format(MEDIUM_DATE_TIME_FORMAT),
)

export const normalizeTime = (hour) => (hour < 10 ? `0${hour}` : hour)

export const generateTime = (hour, minute) => {
  hour = normalizeTime(hour)
  minute = normalizeTime(minute)
  return `${hour}:${minute}`
}

export const addHalfHour = (time) => {
  let hourSection = Number(time.split(':')[0])
  let minuteSection = Number(time.split(':')[1])

  if (minuteSection === 30) {
    hourSection += 1
    minuteSection -= 30
  } else {
    minuteSection += 30
  }
  return generateTime(hourSection, minuteSection)
}

export const decreaseHalfHour = (time) => {
  let hourSection = Number(time.split(':')[0])
  let minuteSection = Number(time.split(':')[1])

  if (minuteSection === 0) {
    hourSection -= 1
    minuteSection += 30
  } else {
    minuteSection -= 30
  }
  return generateTime(hourSection, minuteSection)
}

export const convertUTCToTimezone = (
  date,
  timezone = CALENDAR_DATE_FORMATTED,
) => {
  let setFormatDate = momentTimeZone(date).format(CALENDAR_DATE_FORMATTED)

  return R.isNil(date)
    ? undefined
    : momentTimeZone.utc(setFormatDate).tz(timezone)
}

export const addOneHour = (time) => {
  let hourSection = Number(time.split(':')[0])
  let minuteSection = Number(time.split(':')[1])

  return generateTime((hourSection += 1), minuteSection)
}

export const formatDateFromNow = (date) => {
  const momentDate = moment(date)
  const today = moment().startOf('day')

  if (momentDate.isSameOrAfter(today, 'day')) {
    return momentDate.fromNow()
  }

  return momentDate.format('MMM D, YYYY, h:mm A')
}
